/* BrewTaurus hub — phase 1 (24. 9. 2026). Markup + spec summary: sections/bt-hub.liquid. */
(function () {
  'use strict';
  if (window.__btHubInit) return;

  var root = document.querySelector('[data-bt-hub]');
  if (!root) return;
  window.__btHubInit = true;

  var cfg = {};
  try { cfg = JSON.parse(root.querySelector('[data-hub-config]').textContent) || {}; } catch (e) { cfg = {}; }
  var S = cfg.strings || {};
  var panel = root.querySelector('.bt-hub-panel');
  var overlay = root.querySelector('.bt-hub-overlay');
  var launcher = root.querySelector('[data-hub-launcher]');
  var dot = root.querySelector('[data-hub-dot]');
  if (!panel || !overlay || !launcher) return;

  var RV_KEY = 'bt_hub_rv';      // localStorage: recently viewed handles (preferences consent only)
  var SEEN_KEY = 'bt_hub_seen';  // localStorage: first visit + last seen "what's new" marker (preferences consent only)
  var GEO_KEY = 'bt-geo';        // sessionStorage: shared with snippets/shipping-info.liquid
  var RV_MAX = 8;
  var RV_SHOW = 3;
  var BASE = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var isOpen = false;
  var rvLoaded = false;
  var lastFocus = null;
  var consent = { prefs: false };

  /* ---------- storage ---------- */
  function store(kind) {
    try { return kind === 'session' ? window.sessionStorage : window.localStorage; } catch (e) { return null; }
  }
  function readJSON(s, key, fallback) {
    try { var v = s && s.getItem(key); return v ? JSON.parse(v) : fallback; } catch (e) { return fallback; }
  }
  function writeJSON(s, key, value) {
    try { if (s) s.setItem(key, JSON.stringify(value)); } catch (e) { /* storage full or blocked */ }
  }
  function removeKey(s, key) {
    try { if (s) s.removeItem(key); } catch (e) { /* noop */ }
  }

  /* ---------- consent: preferences = personalisation storage ---------- */
  function evalConsent() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (cp && typeof cp.preferencesProcessingAllowed === 'function') {
      try { consent.prefs = !!cp.preferencesProcessingAllowed(); } catch (e) { consent.prefs = false; }
      return true;
    }
    return false;
  }
  function withConsent(cb) {
    if (evalConsent()) { cb(); return; }
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
          if (err || !evalConsent()) consent.prefs = false;
          cb();
        });
        return;
      } catch (e) { /* fall through */ }
    }
    consent.prefs = false; // no privacy API → do not store anything
    cb();
  }
  document.addEventListener('visitorConsentCollected', function () {
    evalConsent();
    if (!consent.prefs) {
      removeKey(store('local'), RV_KEY);
      removeKey(store('local'), SEEN_KEY);
    }
  });

  /* ---------- analytics ---------- */
  function track(name, params) {
    if (window.Shopify && window.Shopify.designMode) return;
    params = params || {};
    try {
      if (typeof window.gtag === 'function' && cfg.ga4) {
        var p = { send_to: cfg.ga4 };
        for (var k in params) if (Object.prototype.hasOwnProperty.call(params, k)) p[k] = params[k];
        window.gtag('event', name, p);
      }
    } catch (e) { /* noop */ }
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, params);
      }
    } catch (e) { /* noop */ }
  }

  /* ---------- recently viewed ---------- */
  function currentHandle() { return root.getAttribute('data-product-handle') || ''; }
  function rvList() {
    if (!consent.prefs) return [];
    var list = readJSON(store('local'), RV_KEY, []);
    return Array.isArray(list) ? list.filter(function (h) { return typeof h === 'string' && h; }) : [];
  }
  function recordView() {
    var h = currentHandle();
    if (!h || !consent.prefs) return;
    var list = [h].concat(rvList().filter(function (x) { return x !== h; })).slice(0, RV_MAX);
    writeJSON(store('local'), RV_KEY, list);
  }
  function rvToShow() {
    var cur = currentHandle();
    return rvList().filter(function (h) { return h !== cur; });
  }
  function loadRecent() {
    if (rvLoaded) return;
    rvLoaded = true;
    var sec = root.querySelector('[data-hub-recent]');
    var box = root.querySelector('[data-hub-recent-list]');
    var handles = rvToShow().slice(0, RV_SHOW + 2); // two spares in case a product is gone
    if (!sec || !box || !handles.length) return;
    Promise.all(handles.map(function (h) {
      return fetch(BASE + 'products/' + encodeURIComponent(h) + '?view=bt-hub', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : (r.status === 404 ? '__gone__' : ''); })
        .catch(function () { return ''; });
    })).then(function (res) {
      var gone = [];
      var html = [];
      res.forEach(function (t, i) {
        if (t === '__gone__') gone.push(handles[i]);
        else if (t && t.indexOf('bt-hub-card') > -1 && html.length < RV_SHOW) html.push(t);
      });
      if (gone.length) {
        writeJSON(store('local'), RV_KEY, rvList().filter(function (h) { return gone.indexOf(h) < 0; }));
      }
      if (!html.length) return;
      box.innerHTML = html.join('');
      sec.hidden = false;
    });
  }

  /* ---------- free shipping ---------- */
  function shipSection() { return root.querySelector('[data-hub-ship]'); }
  function shipData() {
    var sec = shipSection();
    var el = sec && sec.querySelector('[data-hub-ship-data]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function geoCountry() {
    var g = readJSON(store('session'), GEO_KEY, null);
    return g && g.cc ? String(g.cc).toUpperCase() : null;
  }
  function detectGeo() {
    if (geoCountry()) return Promise.resolve(geoCountry());
    return fetch('/browsing_context_suggestions.json?country%5Benabled%5D=true', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || !j.detected_values || !j.detected_values.country) return null;
        var cc = j.detected_values.country.handle;
        var name = j.detected_values.country.name || cc;
        writeJSON(store('session'), GEO_KEY, { cc: cc, name: name });
        return cc;
      })
      .catch(function () { return null; });
  }
  function setMessage(el, text, amount) {
    el.textContent = '';
    var parts = String(text || '').split('[amount]');
    parts.forEach(function (part, i) {
      if (part) el.appendChild(document.createTextNode(part));
      if (i < parts.length - 1) {
        var b = document.createElement('strong');
        b.textContent = amount;
        el.appendChild(b);
      }
    });
  }
  function shipZone(d, cc) {
    if ((d.all || []).indexOf(cc) > -1) return 'all';
    if ((d.small || []).indexOf(cc) > -1) return 'small';
    return 'none';
  }
  function appendLine(el, text) {
    if (!text) return;
    el.appendChild(document.createTextNode(' ' + text));
  }
  function renderShip() {
    var sec = shipSection();
    if (!sec) return;
    var d = shipData();
    if (!d || !d.t) { sec.hidden = true; return; }
    var cc = geoCountry() || d.country;
    var zone = shipZone(d, cc);
    // shared with snippets/cart-shipping-note.liquid: the cart note shows the variant for this zone
    try { document.documentElement.setAttribute('data-bt-ship-zone', zone); } catch (e) { /* noop */ }
    if (zone === 'none') { sec.hidden = true; return; } // no free-shipping threshold for this country
    var all = zone === 'all';
    var small = zone === 'small';
    // items that can ship free: small items everywhere, large items only in CZ/SK; ingredients never
    var freeable = d.std || (all && d.big);

    var msg = sec.querySelector('[data-hub-ship-msg]');
    var bar = sec.querySelector('[data-hub-ship-bar]');
    var fill = bar && bar.firstElementChild;
    var cartLink = sec.querySelector('[data-hub-cart-link]');
    var pct = null;
    var done = false;

    if (d.total <= 0) {
      setMessage(msg, all ? S.emptyAll : S.emptySmall, d.tm);
    } else if (small && d.big) {
      setMessage(msg, S.big, d.tm); // large item ships at a flat rate — same rule as the cart note
      if (d.cons) appendLine(msg, S.cons);
    } else if (!freeable && d.cons) {
      setMessage(msg, S.cons, d.tm); // only ingredients in the cart: nothing to unlock
    } else if (d.total >= d.t) {
      setMessage(msg, S.done, d.tm);
      if (d.cons) appendLine(msg, S.cons);
      pct = 100;
      done = true;
    } else {
      setMessage(msg, all ? S.leftAll : S.leftSmall, d.missing);
      pct = Math.max(4, Math.min(99, Math.round((d.total / d.t) * 100)));
    }
    if (bar) bar.hidden = pct === null;
    if (fill && pct !== null) fill.style.width = pct + '%';
    sec.classList.toggle('is-done', done);
    if (cartLink) {
      cartLink.hidden = !d.count;
      cartLink.textContent = (S.cart || 'View cart') + ' (' + d.count + ')';
    }
    sec.hidden = false;
  }
  function takeShipIsland(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-hub-ship-data]');
    var sec = shipSection();
    var cur = sec && sec.querySelector('[data-hub-ship-data]');
    if (fresh && cur) cur.textContent = fresh.textContent;
    renderShip();
  }
  function refreshShip() {
    if (!shipSection() || !cfg.sectionId) return;
    fetch(BASE + '?sections=' + encodeURIComponent(cfg.sectionId), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { if (j && j[cfg.sectionId]) takeShipIsland(j[cfg.sectionId]); })
      .catch(function () { /* keep last state */ });
  }

  /* ---------- add to cart from the panel ---------- */
  function applySections(sections) {
    if (!sections) return;
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      var el = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (el) bubble.innerHTML = el.innerHTML;
    }
    if (cfg.sectionId && sections[cfg.sectionId]) takeShipIsland(sections[cfg.sectionId]);
  }
  function showError(btn, text) {
    btn.disabled = false;
    var card = btn.closest('.bt-hub-card');
    if (!card) return;
    var p = card.querySelector('.bt-hub-card__error');
    if (!p) {
      p = document.createElement('p');
      p.className = 'bt-hub-card__error';
      p.setAttribute('role', 'alert');
      card.appendChild(p);
    }
    p.textContent = text || S.error || 'Error';
  }
  function addToCart(btn) {
    var id = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!id || btn.disabled) return;
    var qty = parseInt(btn.getAttribute('data-qty') || '1', 10) || 1; // 10 for malts sold per 100 g
    var list = btn.getAttribute('data-list') || 'other';
    var price = parseInt(btn.getAttribute('data-price') || '0', 10) || 0;
    var title = btn.getAttribute('data-title') || '';
    btn.disabled = true;
    var sections = ['cart-icon-bubble'];
    if (cfg.sectionId) sections.push(cfg.sectionId);
    var addUrl = (window.routes && window.routes.cart_add_url) || BASE + 'cart/add';
    fetch(addUrl + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty }], sections: sections.join(','), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || !res.j || res.j.status) {
          showError(btn, res.j && (res.j.description || res.j.message));
          return;
        }
        btn.textContent = S.added || 'Added';
        btn.classList.add('is-added');
        var err = btn.closest('.bt-hub-card') && btn.closest('.bt-hub-card').querySelector('.bt-hub-card__error');
        if (err) err.remove();
        applySections(res.j.sections);
        track('bt_hub_add_to_cart', {
          hub_section: list,
          currency: cfg.currency,
          value: (price * qty) / 100,
          items: [{ item_id: String(id), item_name: title, price: price / 100, quantity: qty }]
        });
        try {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bt-hub', productVariantId: id, cartData: res.j });
          }
        } catch (e) { /* noop */ }
      })
      .catch(function () { showError(btn, S.error); });
  }

  /* ---------- open / close ---------- */
  function markSeen() {
    if (dot) dot.hidden = true;
    if (!consent.prefs) return;
    var seen = readJSON(store('local'), SEEN_KEY, {}) || {};
    seen.latest = root.getAttribute('data-latest') || '';
    writeJSON(store('local'), SEEN_KEY, seen);
  }
  function open(trigger) {
    if (isOpen) return;
    isOpen = true;
    lastFocus = document.activeElement;
    overlay.hidden = false;
    panel.hidden = false;
    void panel.offsetWidth; // force a reflow so the slide-in transition runs (no rAF: it pauses in background tabs)
    root.classList.add('is-open');
    launcher.setAttribute('aria-expanded', 'true');
    document.body.classList.add('overflow-hidden');
    loadRecent();
    refreshShip();
    markSeen();
    window.setTimeout(function () {
      var closeBtn = panel.querySelector('.bt-hub-panel__close');
      try {
        if (typeof trapFocus === 'function') trapFocus(panel, closeBtn || panel);
        else (closeBtn || panel).focus();
      } catch (e) { panel.focus(); }
    }, 60);
    track('bt_hub_open', { trigger: trigger || 'click' });
  }
  function close() {
    if (!isOpen) return;
    isOpen = false;
    root.classList.remove('is-open');
    launcher.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('overflow-hidden');
    var finish = function () {
      if (isOpen) return;
      panel.hidden = true;
      overlay.hidden = true;
    };
    panel.addEventListener('transitionend', finish, { once: true });
    window.setTimeout(finish, 400);
    var back = lastFocus && document.contains(lastFocus) ? lastFocus : launcher;
    try {
      if (typeof removeTrapFocus === 'function') removeTrapFocus(back);
      else back.focus();
    } catch (e) { /* noop */ }
  }

  /* ---------- returning visitor, "what's new" dot, auto-open ---------- */
  function sessionIsNew() {
    var s = store('session');
    try {
      if (s && !s.getItem('bt_hub_session')) { s.setItem('bt_hub_session', '1'); return true; }
    } catch (e) { /* noop */ }
    return false;
  }
  function initSeen(isNewSession) {
    if (!consent.prefs) return { returning: false };
    var seen = readJSON(store('local'), SEEN_KEY, null) || {};
    var returning = isNewSession && !!seen.first;
    if (!seen.first) seen.first = Date.now();
    var latest = root.getAttribute('data-latest') || '';
    if (typeof seen.latest !== 'string') seen.latest = latest; // first visit sets the baseline, no dot
    else if (latest && seen.latest !== latest && dot) dot.hidden = false;
    writeJSON(store('local'), SEEN_KEY, seen);
    return { returning: returning };
  }
  function blockedPage() {
    var path = window.location.pathname;
    return /\/(cart|account|checkouts?)(\/|$)/.test(path);
  }
  function maybeAutoOpen(state) {
    if (!cfg.autoOpen || !state.returning || blockedPage()) return;
    if (!window.matchMedia || !window.matchMedia('(min-width: 990px)').matches) return; // desktop only
    if (!rvToShow().length) return; // only when there is something personal to show
    var s = store('session');
    try {
      if (!s || s.getItem('bt_hub_auto')) return;
      s.setItem('bt_hub_auto', '1');
    } catch (e) { return; }
    function fire() {
      if (document.visibilityState !== 'visible') {
        // tab in the background: wait until the visitor comes back, then give them a moment
        document.addEventListener('visibilitychange', function onVisible() {
          if (document.visibilityState !== 'visible') return;
          document.removeEventListener('visibilitychange', onVisible);
          window.setTimeout(fire, 1500);
        });
        return;
      }
      var busy = document.querySelector('.cart-notification.active, .menu-drawer-container[open], quick-add-modal[open], .modal__content[open]');
      if (!isOpen && !busy && !document.body.classList.contains('overflow-hidden')) open('auto');
    }
    window.setTimeout(fire, 4000);
  }

  /* ---------- events ---------- */
  launcher.addEventListener('click', function () { if (isOpen) close(); else open('click'); });
  root.querySelectorAll('[data-hub-close]').forEach(function (el) { el.addEventListener('click', close); });
  panel.addEventListener('keyup', function (e) { if (e.key === 'Escape' || e.code === 'Escape') close(); });
  root.addEventListener('click', function (e) {
    var add = e.target.closest('[data-hub-add]');
    if (add && root.contains(add)) { e.preventDefault(); addToCart(add); return; }
    var a = e.target.closest('a[href]');
    if (a && panel.contains(a)) {
      var sec = a.closest('[data-hub-section]');
      track('bt_hub_click', { hub_section: sec ? sec.getAttribute('data-hub-section') : 'other', link_url: a.getAttribute('href') });
    }
  });
  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
        if (ev && ev.source === 'bt-hub') return;
        refreshShip();
      });
    }
  } catch (e) { /* noop */ }

  // theme editor: selecting the section opens the panel
  document.addEventListener('shopify:section:select', function (e) { if (e.target && e.target.contains(root)) open('editor'); });
  document.addEventListener('shopify:section:deselect', function (e) { if (e.target && e.target.contains(root)) close(); });

  /* ---------- init ---------- */
  renderShip();
  detectGeo().then(renderShip);
  withConsent(function () {
    recordView();
    var state = initSeen(sessionIsNew());
    maybeAutoOpen(state);
  });
})();
